class CalculatorLoaderStandart {
    options;
    constructor(options) {
        this.options = options;
    }
    load() {
        return fetch(this.getUrl()).then(resp => resp.json());
    }
    getUrl() {
        return this.options.server + '/' + this.options.name + '/getByName';
    }
}
export default CalculatorLoaderStandart;
